module.exports = __webpack_public_path__ + "img/2.53a5e117.png";